namespace Matrix.Workflow {
    export class WorkflowInstanceColumns {
        static columnsKey = 'Workflow.WorkflowInstance';
    }
}
